import React, { useState } from 'react';
import { Col, Row } from '@design-system-etat/dsfr-react';
import PropTypes from 'prop-types';
import { getAPI } from 'store/apiReducer';
import { connect } from 'react-redux';
import DataTableDesignEtat from '../../../../components/Commun/Table/DataTableDesignEtat';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_GET_RECHERCHE_ARMES_QUOTA_MUNITIONS,
    CONTEXT_GET_RECHERCHE_ARMES_QUOTA_MUNITIONS,
} from '../../../../constants/apiUrls.constants';

const Munitions = ({ getApi, isLoading, formattedData }) => {
    const [clearFilters, setClearFilters] = useState(false);

    const dateToString = (date) => {
        return new Date(date.replaceAll('/', '-').split('-').reverse().join('-'))
            .toISOString()
            .replace(/T.+/g, '');
    };
    const rechercheArmesQuotaMunitions = (params) => {
        let suffixeUrlRecherche = '';
        const queryParameters = {
            ...params,
        };
        Object.entries(queryParameters).forEach((rechercheValue) => {
            if (!rechercheValue[1]) {
                return;
            }
            if (suffixeUrlRecherche === '') {
                suffixeUrlRecherche += '?';
            } else {
                suffixeUrlRecherche += '&';
            }
            if (rechercheValue[0] === 'periodeQuota') {
                suffixeUrlRecherche += `dateFinMunition=${dateToString(rechercheValue[1])}`;
            } else if (rechercheValue[0] === '_sort' && rechercheValue[1] === 'periodeQuota') {
                suffixeUrlRecherche += `${rechercheValue[0]}=dateFinMunition`;
            } else if (rechercheValue[0] === 'dateMiseEnStock') {
                suffixeUrlRecherche += `${rechercheValue[0]}=${dateToString(rechercheValue[1])}`;
            } else if (rechercheValue[0] === 'quotaMunitionsDisplay') {
                suffixeUrlRecherche += `quotaUtiliseMunition=${rechercheValue[1]}`;
            } else if (
                rechercheValue[0] === '_sort' &&
                rechercheValue[1] === 'quotaMunitionsDisplay'
            ) {
                suffixeUrlRecherche += `${rechercheValue[0]}=quotaUtiliseMunition`;
            } else {
                suffixeUrlRecherche += `${rechercheValue[0]}=${rechercheValue[1]}`;
            }
        });
        if (clearFilters) {
            setClearFilters(false);
        }
        getApi(
            usagerClientReducer,
            API_GET_RECHERCHE_ARMES_QUOTA_MUNITIONS + suffixeUrlRecherche,
            CONTEXT_GET_RECHERCHE_ARMES_QUOTA_MUNITIONS,
        );
    };

    const tableauConfig = [
        { field: 'numEncodage', header: 'N° encodage', sortable: true, filter: true },
        { field: 'calibreCanon', header: 'Calibre', sortable: true, filter: true },
        { field: 'dateMiseEnStock', header: "Date d'acquisition", sortable: true, filter: true },
        {
            field: 'periodeQuota',
            header: 'Période ',
            sortable: true,
            filter: false,
            bodyStyle: { width: '15em' },
        },
        {
            field: 'quotaMunitionsDisplay',
            header: 'Quota',
            sortable: true,
            filter: false,
            bodyStyle: { textAlign: 'right' },
        },
    ];

    return (
        <>
            <Row goutierre>
                <Col col={12}>
                    <DataTableDesignEtat
                        columns={tableauConfig}
                        records={
                            formattedData && formattedData.records ? formattedData.records : []
                        }
                        nombreTotal={formattedData && formattedData.nombreTotal}
                        recherche={rechercheArmesQuotaMunitions}
                        clearFiltersButton
                        clearFiltersForce={clearFilters}
                        isLoading={isLoading}
                        rechercheIcon
                        pointDeRuptureResponsive="lg"
                        emptyMessage="Aucun résultat trouvé"
                    />
                </Col>
            </Row>
        </>
    );
};

Munitions.propTypes = {
    getApi: PropTypes.func.isRequired,
    formattedData: PropTypes.shape({
        nombreTotal: PropTypes.number.isRequired,
        records: PropTypes.array,
    }),
    isLoading: PropTypes.bool,
};

const formaterAffichageDate = (date) => {
    return new Date(date).toLocaleDateString('fr-FR');
};

const formaterAffichageDateMoinsUnAn = (date) => {
    const dateMoinsUnAn = new Date(date);
    dateMoinsUnAn.setFullYear(dateMoinsUnAn.getFullYear() - 1);
    return dateMoinsUnAn.toLocaleDateString('fr-FR');
};

const formaterAffichageMunitions = (data) => {
    /* eslint-disable no-param-reassign */
    if (data) {
        const formattedData = JSON.parse(JSON.stringify(data));
        formattedData.records.forEach((record) => {
            record.periodeQuota = record.dateFinMunition
                ? `${formaterAffichageDateMoinsUnAn(
                      record.dateFinMunition,
                  )} - ${formaterAffichageDate(record.dateFinMunition)}`
                : ``;
            record.dateMiseEnStock = record.dateMiseEnStock
                ? formaterAffichageDate(record.dateMiseEnStock)
                : formaterAffichageDate(record.dateInit);
            record.quotaMunitionsDisplay = `${record.quotaUtiliseMunition ?? 0}/3000`;
        });
        return formattedData;
    }
    return data;
};

export default connect(
    (state) => {
        const { isLoading, data } = state.recherche.armesQuotaMunitions;
        const formattedData = formaterAffichageMunitions(data);
        return {
            isLoading,
            formattedData,
        };
    },
    {
        getApi: getAPI,
    },
)(Munitions);
